"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.polygonsDeserialize = exports.polygonDeserialize = void 0;
const deserializeArray_1 = __importDefault(require("./deserializeArray"));
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
function polygonDeserialize(value) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        coordinatesEncoded: (0, deserializeString_1.deserializeString)(object.coordinatesEncoded),
        // coordinates: coordinatesArraysDeserialize(object.coordinates),
    };
}
exports.polygonDeserialize = polygonDeserialize;
exports.polygonsDeserialize = (0, deserializeArray_1.default)(polygonDeserialize);
